import React from 'react';
import tw, { styled } from 'twin.macro';
import PropTypes from 'prop-types';

import { Indicator as BaseIndicator } from '@ubisend/pulse-components';

const FatIndicator = styled(BaseIndicator)`
  ${tw`w-3 h-3 mr-2`}
`;

// State constants for better maintainability
const STATES = {
  SUCCESS: 'Success',
  FAILED: 'Failed',
  PENDING: 'Pending',
  PREPARING: 'Preparing',
  DELETING: 'Deleting',
  DOWNLOADING: 'Downloading',
  MANUALLY_DELETE: 'Manually Deleted'
};

// Color mapping for different states
const getStateColor = state => {
  switch (state) {
    case STATES.SUCCESS:
      return 'positive';
    case STATES.FAILED:
    case STATES.DELETING:
    case STATES.MANUALLY_DELETE:
      return 'danger';
    case STATES.PENDING:
    case STATES.PREPARING:
    case STATES.DOWNLOADING:
    default:
      return 'warning';
  }
};

const StateIndicator = ({ state }) => (
  <FatIndicator colour={getStateColor(state)} />
);

StateIndicator.propTypes = {
  state: PropTypes.string.isRequired
};

const levels = {
  [STATES.SUCCESS]: () => <StateIndicator state={STATES.SUCCESS} />,
  [STATES.FAILED]: () => <StateIndicator state={STATES.FAILED} />,
  [STATES.PENDING]: () => <StateIndicator state={STATES.PENDING} />,
  [STATES.PREPARING]: () => <StateIndicator state={STATES.PREPARING} />,
  [STATES.DELETING]: () => <StateIndicator state={STATES.DELETING} />,
  [STATES.DOWNLOADING]: () => <StateIndicator state={STATES.DOWNLOADING} />,
  [STATES.MANUALLY_DELETE]: () => (<StateIndicator state={STATES.MANUALLY_DELETE} />)
};

const StateLevel = ({ level }) => {
  if (!levels[level]) {
    return <StateIndicator state={STATES.PREPARING} />;
  }

  const Indicator = levels[level];

  return <Indicator />;
};

StateLevel.propTypes = {
  level: PropTypes.string.isRequired
};

export default StateLevel;